/**
 * PDP FAQ: category pills, top 3 per filter, in-box readmore toggle.
 * @version 1.0.0
 * @lastModified 2026-10-14
 */
(function () {
  var VISIBLE_LIMIT = 3;

  function snoozebabyProductFaqThemeLabel(host, filter) {
    if (!filter || filter === 'all') return '';
    return host.getAttribute('data-sb-faq-theme-' + filter) || '';
  }

  function snoozebabyProductFaqInitHost(host) {
    if (!host || host.dataset.sbFaqReady === '1') return;

    var list = host.querySelector('[data-sb-faq]');
    var pills = host.querySelector('[data-sb-faq-pills]');
    var expandBtn = host.querySelector('[data-sb-faq-expand]');
    if (!list || !pills) return;

    var items = Array.prototype.slice.call(
      list.querySelectorAll('.sb-product-faq__item[data-sb-faq-category]')
    );
    if (!items.length) return;

    var activeFilter = 'all';
    var expanded = false;

    function countForFilter(filter) {
      if (filter === 'all') return items.length;
      return items.filter(function (item) {
        return item.getAttribute('data-sb-faq-category') === filter;
      }).length;
    }

    function updatePillCounts() {
      pills.querySelectorAll('[data-sb-faq-filter]').forEach(function (pill) {
        var filter = pill.getAttribute('data-sb-faq-filter');
        var countEl = pill.querySelector('[data-sb-faq-pill-count]');
        if (countEl) countEl.textContent = '(' + countForFilter(filter) + ')';
      });
    }

    function visibleItems() {
      return items.filter(function (item) {
        if (activeFilter !== 'all' && item.getAttribute('data-sb-faq-category') !== activeFilter) {
          return false;
        }
        return true;
      });
    }

    function applyListState() {
      var visible = visibleItems();
      items.forEach(function (item) {
        item.classList.add('sb-product-faq__item--hidden');
      });
      visible.forEach(function (item, index) {
        if (expanded || index < VISIBLE_LIMIT) {
          item.classList.remove('sb-product-faq__item--hidden');
        }
      });

      var footer = list.querySelector('[data-sb-faq-footer]');
      if (!footer || !expandBtn) return;

      if (visible.length > VISIBLE_LIMIT) {
        footer.hidden = false;
        var moreTpl = host.getAttribute('data-sb-faq-label-more') || '';
        var moreThemeTpl = host.getAttribute('data-sb-faq-label-more-theme') || '';
        var lessLabel = host.getAttribute('data-sb-faq-label-less') || '';
        if (expanded) {
          expandBtn.textContent = lessLabel;
        } else {
          var themeLabel = snoozebabyProductFaqThemeLabel(host, activeFilter);
          var tpl = themeLabel ? moreThemeTpl : moreTpl;
          expandBtn.textContent = tpl
            .replace(/\{count\}/g, String(visible.length))
            .replace(/\{theme\}/g, themeLabel);
        }
      } else {
        footer.hidden = true;
        expanded = false;
      }
    }

    pills.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-sb-faq-filter]');
      if (!pill || !pills.contains(pill)) return;
      var next = pill.getAttribute('data-sb-faq-filter');
      if (!next || next === activeFilter) return;
      activeFilter = next;
      expanded = false;
      pills.querySelectorAll('.sb-faq-pill').forEach(function (el) {
        var isActive = el === pill;
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      list.querySelectorAll('details').forEach(function (details) {
        details.open = false;
      });
      applyListState();
    });

    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        expanded = !expanded;
        applyListState();
      });
    }

    list.addEventListener(
      'toggle',
      function (event) {
        var target = event.target;
        if (target.tagName !== 'DETAILS' || !target.open) return;
        list.querySelectorAll('details').forEach(function (item) {
          if (item !== target) item.open = false;
        });
      },
      true
    );

    updatePillCounts();
    applyListState();
    host.dataset.sbFaqReady = '1';
  }

  function snoozebabyProductFaqInit() {
    document.querySelectorAll('[data-sb-faq-host]').forEach(snoozebabyProductFaqInitHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', snoozebabyProductFaqInit);
  } else {
    snoozebabyProductFaqInit();
  }
})();
